import React, { useEffect } from "react";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AssetType() {
  const [AssetType, SetAssetType] = useState([]);
  const [SelectedType, SetSelectedType] = useState([]);

  const InitState = {
    Status: null,
    StatusRef: null,
  };
  const [Details, setDetails] = useState(InitState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    let result = pattern.test(value);
    if (result) {
      setDetails({
        ...Details,
        [name]: value.replace(pattern, "").toUpperCase(),
      });
    } else {
      setDetails({
        ...Details,
        [name]: value.toUpperCase(),
      });
    }
  };
  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    let result = pattern.test(value);
    if (result) {
      SetSelectedType({
        ...SelectedType,
        [name]: value.replace(pattern, "").toUpperCase(),
      });
    } else {
      SetSelectedType({
        ...SelectedType,
        [name]: value.toUpperCase(),
      });
    }
  };

  const handleEdit = (items) => {
    const InitStateEdit = {
      Id: items.Id,
      Status: items.Status,
      StatusRef: items.Status_Ref,
    };
    SetSelectedType(InitStateEdit);
    //console.log(InitStateEdit);
  };

  const fetchAssetType = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Asset_Type`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetAssetType(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchAssetType();
  }, []);

  const UpdateForm = async (event) => {
    event.preventDefault();
    try {
      await axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/UpdateStatusTypeSub/Asset_Type`,
          SelectedType,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          SetSelectedType([]);
          fetchAssetType();
        })
        .catch((err) => {
          if (err.response && err.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const handleDelete = (items) => {
    try {
      axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/statusType/DeleteAssetType`,
          items,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          fetchAssetType();
        })
        .catch((err) => {
          if (err.response && err.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    //console.log(Details);
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/AddStatusTypeSub/Asset_Type`,
          Details,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
          }
          if (res.status === 201) {
            WarningMSG(res.data.message);
          }
          setDetails([]);
          fetchAssetType();
        })
        .catch((err) => {
          if (err.response && err.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };
  return (
    <>
      <ToastContainer />
      <div className="MSContainer">
        <div className="MSContainerChild">
          <p className="MSCHead">Asset Type</p>
          <form
            className="MSForm"
            onSubmit={SelectedType.Id ? UpdateForm : handleSubmit}
          >
            <div className="MSFormInputs">
              <input
                className="MSFormInput1"
                type="text"
                value={
                  SelectedType.Status ? SelectedType.Status : Details.Status
                }
                onChange={SelectedType.Id ? handleUpdate : handleChange}
                name="Status"
                placeholder="Enter Type"
                required
              ></input>
            </div>
            <button className="MSFormSubmitBtn" type="submit">
              Save
            </button>
          </form>
        </div>
        <div className="MSContainerChild1">
          <div className="MSCTHeads">
            <p className="MSCTHLabels">Asset Type</p>
            <div className="MSCTBtns"></div>
          </div>
          {AssetType.length < 1 ? (
            <p> No Type Found</p>
          ) : (
            AssetType.map((items) => {
              return (
                <div className="MSCTiles">
                  <p className="MSCTLabels">{items.Status}</p>
                  <div className="MSCTBtns">
                    <FontAwesomeIcon
                      className="MSCTEditIcon"
                      title="Edit"
                      onClick={() => handleEdit(items)}
                      icon={faEdit}
                    ></FontAwesomeIcon>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </>
  );
}

//<FontAwesomeIcon className='MSCTDeleteIcon' title='Delete' onClick={()=>handleDelete(items)} icon={faTrash}></FontAwesomeIcon>
